// extracted by mini-css-extract-plugin
module.exports = {"resend_btn":"SendCode_resend_btn__SH0Rj","rest_num":"SendCode_rest_num___TxYe"};